// extracted by mini-css-extract-plugin
module.exports = {"card":"PaymentPlanCardPlaceholder_card__2HYIi","content":"PaymentPlanCardPlaceholder_content__k6mNk"};